/* Svensk katalog for locale-registry-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'control.example': 'Skapa en faktura, lägg upp en leverantör eller ändra e-postadressen för en kund …',
  'registry.customer': 'Kunder',
  'registry.supplier': 'Leverantörer',
  'registry.product': 'Produkter',
  'registry.description': 'Beskrivning',
  'registry.price': 'Enhetspris exkl. moms',
  'registry.type': 'Typ',
  'registry.vat': 'Momshantering',
  'registry.sku': 'SKU',
  'registry.ean': 'EAN/GTIN',
  'registry.group': 'Produktgrupp',
  'registry.goods': 'Vara',
  'registry.service': 'Tjänst',
  'registry.choose': 'Välj …',
  'registry.newDraft': 'Ny post – inte sparad',
  'registry.selected': 'Vald: {name}',
  'registry.archivedLabel': 'Arkiverad',
  'registry.matches': '{count} träffar. Visar {shown}. Förfina sökningen om flera passar.',
  'registry.working': 'Arbetar i registret …',
  'registry.review': 'Kontrollera uppgifterna i registerpanelen.',
  'registry.done.observed': 'Registret är öppnat och träffarna visas.',
  'registry.done.opened': 'Registerposten är öppnad.',
  'registry.repeatedRead': 'Samma registersökning har redan utförts. Kontrollera träffarna som visas innan du fortsätter.',
  'registry.done.applied': 'Fälten är ifyllda. Ändringarna är inte sparade ännu.',
  'registry.done.saved': 'Registerposten har sparats.',
  'registry.done.archived': 'Registerposten har arkiverats.',
  'registry.done.restored': 'Leverantören är aktiv igen.',
  'registry.done.unchanged': 'Inga nya ändringar att spara.',
  'registry.changed': 'Posten har ändrats sedan den öppnades. Stäng registerpanelen och be mig hämta den på nytt.',
  'registry.selectFirst': 'Sök upp och välj rätt registerpost först.',
  'registry.unsupportedField': 'Detta fält stöds inte här. Använd det vanliga formuläret på sidan.',
  'registry.unsupported': 'Denna åtgärd måste göras i det vanliga formuläret på sidan.',
  'registry.advancedProduct': 'Ändring av moms/typ, abonnemang och uthyrning måste göras i det vanliga produktformuläret.',
  'registry.archived': 'Posten är arkiverad och kan inte redigeras här.',
  'registry.authorization': 'Beskriv uttryckligen vad du vill spara, arkivera eller återöppna.',
  'registry.country': 'Automatisk registersparning stöds än så länge för norska företag. Använd det vanliga formuläret för detta företag.',
  'registry.uncertain': 'Sparningen bekräftades inte. Kontrollera posten på sidan innan du försöker igen.',
  'registry.unsaved': 'Det finns osparade ändringar i registerpanelen. Spara eller stäng panelen först.',
  'registry.duplicate': 'En annan post har samma namn eller organisationsnummer. Stäng panelen och välj rätt befintlig post, eller använd det vanliga formuläret.',
});
